@if (isLoading) {
  <div class="flex justify-center">
    <p-progressSpinner />
  </div>
}
<mnc-attach-to-authorization-form
  lazyComponent
  [hidden]="isLoading"
  [sourceContainer]="'inboundfax'"
  [memberDob]="inboundFax.memberDOB"
  [memberFullName]="inboundFax.memberFullName"
  [memberSubscriberNumber]="inboundFax.memberSubscriberNumber"
  [memberId]="inboundFax.memberId"
  [memberTenantId]="inboundFax.memberTenantId"
  [memberLobId]="inboundFax.memberLobId"
  [product]="product"
  [tenantLobProductId]="tenantLobProductId"
  [faxReceivedDateTime]="inboundFax.faxReceivedDateTime"
  [sourceFileLocation]="inbox.basePath + '/' + inboundFax.documentStorageLocation"
  [documentStorageLocation]="inboundFax.documentStorageLocation"
  (cancelClicked)="ref.close()"
  (errorOccurred)="
    notificationService.showError(
      $event?.detail?.title,
      $event?.detail?.message
    )
  "
  (completedUpload)="onComplete($event)"
  (initCompleted)="isLoading = false"
  />
